import TypeToReducer from 'type-to-reducer';
import set from 'lodash/set';
import moment from 'moment';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  RESET_DEPRECIATION_FORM,
  GET_DEPRECIATION_BY_ID,
  GET_DEPRECIATION_FORM_CONFIG,
  MODIFY_EDITING_DEPRECIATION,
  MODIFY_CUSTOM_FIELD_EDITING_DEPRECATION, //Groups
  ADD_YEAR_EDITING_DEPRECIATION,
  REMOVE_YEAR_EDITING_DEPRECIATION,
} from 'depreciations/constants';

export const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: { rates: [{ date: new Date().toISOString(), percentages: [] }] },
};

export const resetForm = (state) => ({ ...initialState });

export const getByIdPending = (state) => ({ ...state, isFetching: true });

export const getByIdRejected = (state) => ({ ...state, isFetching: false });

export const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.depreciation },
});

export const getConfigPending = (state) => ({ ...state, isFetchingConfig: true });
export const getConfigRejected = (state) => ({ ...state, isFetchingConfig: false });
export const getConfigFulfilled = (state) => ({ ...state, isFetchingConfig: false }); //TODO: no hace nada?????

export const modifyDepreciation = (state, { payload }) => ({
  ...state,
  editing: {
    ...Object.keys(payload).reduce(
      (re, k) => {
        set(re, k, payload[k]);
        return re;
      },
      { ...state.editing }
    ),
  },
});

export const addYear = (state) => ({
  ...state,
  editing: {
    ...state.editing,
    rates: [
      {
        ...state.editing.rates[0],
        percentages: [...state.editing.rates[0].percentages, 0],
      },
    ],
  },
});
export const removeYear = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    rates: [
      {
        ...state.editing.rates[0],
        percentages: [...state.editing.rates[0].percentages.filter((p, i) => i !== payload)],
      },
    ],
  },
});

//Groups
export const modifyCustomField = (state, { payload }) => {
  findAndModify(state.editing._custom, payload);
  return {
    ...state,
    editing: {
      ...state.editing,
      ...payload,
    },
  };
};

export const findAndModify = (_custom, payload) => {
  const keys = Object.getOwnPropertyNames(payload);
  const key = keys[0];
  const value = payload[key];
  let banderaExiste = false;
  _custom.forEach((element) => {
    if (element.key == key) {
      element.value = value;
      banderaExiste = true;
    }
  });
  if (!banderaExiste) _custom.push({ key, value });
  return _custom;
};
//Groups

const reducers = {
  [RESET_DEPRECIATION_FORM]: resetForm,
  [GET_DEPRECIATION_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [GET_DEPRECIATION_FORM_CONFIG]: {
    [PENDING]: getConfigPending,
    [REJECTED]: getConfigRejected,
    [FULFILLED]: getConfigFulfilled,
  },
  [MODIFY_EDITING_DEPRECIATION]: modifyDepreciation,
  [ADD_YEAR_EDITING_DEPRECIATION]: addYear,
  [MODIFY_CUSTOM_FIELD_EDITING_DEPRECATION]: modifyCustomField, //Groups
  [REMOVE_YEAR_EDITING_DEPRECIATION]: removeYear,
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/reducers/depreciations_form_reducers.js